/*
 * Copyright (c) 2020. American Express Company
 */

import React from 'react';
import { TransactionType } from './transaction-type.enum';

export class CategoryModel {
    id?: string;
    name: string;
    parentId?: string;
    userId?: number;
    planUid?: string;
    icon?: React.ComponentType; // added by frontend to display icons with parent categories;
    subcategories?: CategoryModel[];
    transactionType?: TransactionType | string;
}

export type ClickableCategoryModel = CategoryModel & { onClick?: () => void };

export class Categorizable {
    groupId: string;
    groupName?: string; // for sorting, from BudgetModel
    spent?: number; // for sorting, from SpendingSumModel
    parentGroupId?: string; // added by FE
}
